'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _PlaylistAlbumCover = require('components/Playlist/PlaylistAlbumCover/PlaylistAlbumCover');

var _PlaylistAlbumCover2 = _interopRequireDefault(_PlaylistAlbumCover);

var _PlaylistAlbumInfo = require('components/Playlist/PlaylistAlbumInfo/PlaylistAlbumInfo');

var _PlaylistAlbumInfo2 = _interopRequireDefault(_PlaylistAlbumInfo);

var _WatermarkWarning = require('components/Playlist/WatermarkWarning/WatermarkWarning');

var _WatermarkWarning2 = _interopRequireDefault(_WatermarkWarning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./PlaylistAlbum.scss');

var PlaylistAlbum = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(PlaylistAlbum, _PureComponent);

  function PlaylistAlbum() {
    (0, _classCallCheck3.default)(this, PlaylistAlbum);
    return (0, _possibleConstructorReturn3.default)(this, (PlaylistAlbum.__proto__ || (0, _getPrototypeOf2.default)(PlaylistAlbum)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlaylistAlbum, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          album = _props.album;


      if ((0, _isEmpty3.default)(album)) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: (0, _bind2.default)(styles.album, className) },
        _react2.default.createElement(
          'div',
          { className: styles.mainInfo },
          _react2.default.createElement(_PlaylistAlbumCover2.default, { album: album }),
          _react2.default.createElement(_PlaylistAlbumInfo2.default, { album: album })
        ),
        !!album.isWatermark && _react2.default.createElement(_WatermarkWarning2.default, { className: styles.watermark, projectType: album.audiovideo })
      );
    }
  }]);
  return PlaylistAlbum;
}(_react.PureComponent), _class.propTypes = {
  album: _propTypes2.default.object,
  className: _propTypes2.default.string
}, _class.defaultProps = {
  album: {}
}, _temp);
exports.default = PlaylistAlbum;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Playlist/PlaylistAlbum/PlaylistAlbum.js
// module id = 2040
// module chunks = 1